import {countriesToStates, validCountries} from './settings';

export const poBoxNotInAddress = function(value, field, model, messages=null) {
    let poBoxStrings = ['po box', 'p.o. box', 'pobox', 'p.o.box'];
    if (value) {
        for (let poBoxString of poBoxStrings) {
            if (value.toLowerCase().includes(poBoxString)) {
                if (!messages) {
                    return ["Unfortunately, we don't support shipping to PO Boxes. Please enter a valid address that is not a PO box."];
                } else {
                    return [messages.poBoxNotInAddress];
                }
            }
        }
    }
    return [];
}


export const ampersandNotInAddress = function(value, field, model, messages=null) {
    if (value && value.includes("&")) {
        if (!messages) {
            return ["Addresses can not contain '&'."];
        } else {
            return [messages.ampersandNotInAddress];
        }
    }
    return [];
}

export const lengthValidator = function(value, field, model, messages=null) {
    if (value.length > 35) {
        if (!messages) {
            return ["Length has to be less than 35 characters"];
        } else {
            return [messages.ampersandNotInAddress];
        }
    }
    return [];
}


export const invalidState = function(value, field, model, messages=null) {
    let country = model.country ? model.country.toLowerCase() : ""
    if (country in countriesToStates) {
        let states = countriesToStates[country].map(state => state.toLowerCase());
        if (value && !(states.includes(value.toLowerCase()))) {
            if (!messages) {
                return ["You have entered an invalid state for the selected country."];
            } else {
                return [messages.invalidState];
            }
        }
    }
    return [];
}


export const invalidCountry = function(value, field, model, messages=null) {
    if (value && !validCountries.includes(value.toLowerCase())) {
        if (!messages) {
            return ["Please contact your Sales Representative if you wish to ship to this country."];
        } else {
            return [messages.invalidCountry];
        }
    }
    return [];
}